import { useState, Fragment } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import './response-section.sass'
import messages from '../../messages'
import API from '../../api'

function WasThisHelpful({ type, shopSlug }) {
  const intl = useIntl()
  const [helpful, triggerHelpful] = useState(true)
  const [showFeedbackSection, triggerFeedbackSection] = useState(false)
  const [feedback, changeFeedback] = useState('')
  const [isFeedbackSubmitted, triggerSubmit] = useState(false)

  function handleFeedbackChange(e) {
    changeFeedback(e.target.value)
  }

  function handleFeedbackSection(value) {
    triggerFeedbackSection(true)
    triggerHelpful(value)
  }

  function sendFeedback() {
    API(`shop/${shopSlug}/send-airtable/`).post({
      feedback,
      helpful,
      page_section: type,
      page: window.location.href,
    })
    triggerSubmit(true)
  }

  if(isFeedbackSubmitted) {
    return (<div className='response-section'>
      <FormattedMessage id='thank_for_feedback' defaultMessage='Thank you for the feedback' />
    </div>)
  }
  return (
    <div className='response-section text-uppercase'>
      { !showFeedbackSection ? (
        <Fragment>
          <FormattedMessage id='was_this_helpful' defaultMessage='Was this helpful' />
          <span className='buttons' onClick={() => handleFeedbackSection(true)}>
            <i className='font-icons icon-thumbs-up' /><FormattedMessage id='yes' defaultMessage='Yes' />
          </span>
          <span className='buttons' onClick={() => handleFeedbackSection(false)}>
            <i className='font-icons icon-thumbs-down' /><FormattedMessage id='no' defaultMessage='No' />
          </span>
        </Fragment>
      ) : (
        <Fragment>
          <input placeholder={intl.formatMessage(helpful ? messages.whatShouldWeAdd : messages.whatIsMissing)} type='text' value={feedback} onChange={handleFeedbackChange} />
          <button className='btn-red' onClick={() => sendFeedback()} >
            <FormattedMessage id='send' defaultMessage='Send' />
          </button>
        </Fragment>)
      }
    </div>
  )
}

export default WasThisHelpful
